import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { LoggerService } from '../../../services/logger/logger.service';
import { SmartCardStatus } from '../models/smart-card-status';

@Injectable()
export class SmartCardConnectionHttpService {
  constructor(
    private http: HttpClient,
    private loggerService: LoggerService,
  ) {
  }

  private get smartCardBaseUrl(): string {
    return environment.smartCardUrl;
  }

  get isConfigured(): boolean {
    return !!this.smartCardBaseUrl;
  }

  getSmartCardDeviceStatus(): Observable<SmartCardStatus> {
    return this.http
      .get(`${this.smartCardBaseUrl}/api/status`)
      .pipe(
        map((result: any) => {
          return SmartCardStatus.createFromAny(result);
        }),
        catchError((error) => {
          this.loggerService.error(error);
          return of(null);
        })
      );
  }

  controlShutter(isOpened: boolean): Observable<boolean> {
    if (isOpened) {
      return this.http
        .post(`${this.smartCardBaseUrl}/api/open_shutter`, {})
        .pipe(
          map((result: any) => {
            return true;
          }),
          catchError((error) => {
            this.loggerService.error(error);
            return of(false);
          })
        );
    } else {
      return this.http
        .post(`${this.smartCardBaseUrl}/api/close_shutter`, {})
        .pipe(
          map((result: any) => {
            return true;
          }),
          catchError((error) => {
            this.loggerService.error(error);
            return of(false);
          })
        );
    }
  }

  dispenserToInitialPos(): Observable<boolean> {
    return this.http
      .post(`${this.smartCardBaseUrl}/api/move_to_pos1`, {})
      .pipe(
        map((result: any) => {
          return true;
        }),
        catchError((error) => {
          this.loggerService.error(error);
          return of(false);
        })
      );
  }

  dispenserDispenseCard(): Observable<boolean> {
    return this.http
      .post(`${this.smartCardBaseUrl}/api/move_to_pos2`, {})
      .pipe(
        map((result: any) => {
          return true;
        }),
        catchError((error) => {
          this.loggerService.error(error);
          return of(false);
        })
      );
  }

  ejectCard(): Observable<boolean> {
    return this.http
      .post(`${this.smartCardBaseUrl}/api/move_to_pos3`, {})
      .pipe(
        map((result: any) => {
          return true;
        }),
        catchError((error) => {
          this.loggerService.error(error);
          return of(false);
        })
      );
  }

  moveToContactlessAntenna(): Observable<boolean> {
    return this.http
      .post(`${this.smartCardBaseUrl}/api/move_to_contactless_antenna`, {})
      .pipe(
        map((result: any) => {
          return true;
        }),
        catchError((error) => {
          this.loggerService.error(error);
          return of(false);
        })
      );
  }

  moveToChipPosition(): Observable<boolean> {
    return this.http
      .post(`${this.smartCardBaseUrl}/api/move_to_chip_position`, {})
      .pipe(
        map((result: any) => {
          return true;
        }),
        catchError((error) => {
          this.loggerService.error(error);
          return of(false);
        })
      );
  }

  mechanicToChipPosition(): Observable<boolean> {
    return this.http
      .post(`${this.smartCardBaseUrl}/api/mechanic_to_chip_position`, {})
      .pipe(
        map((result: any) => {
          return true;
        }),
        catchError((error) => {
          this.loggerService.error(error);
          return of(false);
        })
      );
  }

  mechanicToCaptureCard(): Observable<boolean> {
    return this.http
      .post(`${this.smartCardBaseUrl}/api/mechanic_to_capture_card`, {})
      .pipe(
        map((result: any) => {
          return true;
        }),
        catchError((error) => {
          this.loggerService.error(error);
          return of(false);
        })
      );
  }

  intakeCard(): Observable<boolean> {
    return this.http
      .post(`${this.smartCardBaseUrl}/api/intake_card`, {})
      .pipe(
        map((result: any) => {
          return true;
        }),
        catchError((error) => {
          this.loggerService.error(error);
          return of(false);
        })
      );
  }

  mechanicToTransportPosition(): Observable<boolean> {
    return this.http
      .post(`${this.smartCardBaseUrl}/api/mechanic_to_transport_position`, {})
      .pipe(
        map((result: any) => {
          return true;
        }),
        catchError((error) => {
          this.loggerService.error(error);
          return of(false);
        })
      );
  }

  piccDetect(): Observable<boolean> {
    return this.http
      .post(`${this.smartCardBaseUrl}/api/picc_detect`, {})
      .pipe(
        map((result: any) => {
          return true;
        }),
        catchError((error) => {
          this.loggerService.error(error);
          return of(false);
        })
      );
  }

  rereadCardProcedure(): Observable<boolean> {
    return this.http
      .post(`${this.smartCardBaseUrl}/api/reread_card_procedure`, {})
      .pipe(
        map((result: any) => {
          return true;
        }),
        catchError((error) => {
          this.loggerService.error(error);
          return of(false);
        })
      );
  }

  doProduceCardProcedure(): Observable<boolean> {
    return this.http
      .post(`${this.smartCardBaseUrl}/api/produce_card_procedure`, {})
      .pipe(
        map((result: any) => {
          return true;
        }),
        catchError((error) => {
          this.loggerService.error(error);
          return of(false);
        })
      );
  }

  doReleaseCardProcedure(): Observable<boolean> {
    return this.http
      .post(`${this.smartCardBaseUrl}/api/release_card_procedure`, {})
      .pipe(
        map((result: any) => {
          return true;
        }),
        catchError((error) => {
          this.loggerService.error(error);
          return of(false);
        })
      );
  }
}
